/** Which side of a conversation a Stream member id is on, read from its shape (AI-3131).
 *  Mirrors the backend's ParseMember: `emp_<id>` is a recruiter, bare digits the legacy company. */

export const SYSTEM_MEMBER_ID = 'system';

const PERSONA = /^[a-z0-9]+_(ajt|mk|rb)$/;

export function isCareerFairMember(id: string): boolean {
  return id.startsWith('js_cf_');
}

export function isJobseekerMember(id: string): boolean {
  return id.startsWith('js_');
}

export function isEmployerSide(id: string): boolean {
  return id.startsWith('emp_') || /^\d+$/.test(id);
}

export function isPersonaMember(id: string): boolean {
  return !isJobseekerMember(id) && !isEmployerSide(id) && PERSONA.test(id);
}

/** The other side of the conversation from the employer's seat: the jobseeker, else
 *  whoever is not on the employer side (a persona), else anyone but me. */
export function counterpartOf(memberIds: readonly string[], self: string): string {
  return (
    memberIds.find(isJobseekerMember) ??
    memberIds.find((id) => id !== SYSTEM_MEMBER_ID && !isEmployerSide(id)) ??
    memberIds.find((id) => id !== self) ??
    self
  );
}
